var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67538 1.51884L6.65611 1.99617L6.41946 0.912648L10.2066 0.0175705L11.0118 4.16026L9.96482 4.38071L9.53715 2.17967L7.0867 6.21526L2.47739 6.20732L1.01812 11.0018L0.000574446 10.6666L1.69613 5.09471L6.4991 5.10299L8.67538 1.51884Z",
    fill: "#52C13C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/profitIcon.00620acf6f542c6aecff35da832f677f.svg";
export { ForwardRef as ReactComponent };